import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from '@/interfaces';
import { UploadImagePayload } from '@/interfaces/aws';

class AwsService {
	constructor(private client: AxiosInstance) {}

	async uploadImage(file: File): Promise<HttpResponse<UploadImagePayload>> {
		const formData = new FormData();
		formData.append('file', file);
		return this.client.post('/upload', formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	}

	async getFileByPath(path: string): Promise<File> {
		return this.client.get(`/upload?path=${path}`, {
			responseType: 'blob',
		});
	}
}

export const awsService = new AwsService(axiosClient);
